import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useDashboard } from '../../hooks/useDashboard';

const AppShell = () => {
  // Single source of truth for dashboard state — propagated to pages via Outlet context
  // so nested routes don't open duplicate WebSocket connections / polling intervals.
  const dashboard = useDashboard();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="app-shell">
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Topbar
        environment={dashboard.environment}
        setEnvironment={dashboard.setEnvironment}
        lastUpdated={dashboard.lastUpdated}
        onMobileMenu={() => setMobileOpen((v) => !v)}
      />
      <main className="app-main">
        <Outlet context={dashboard} />
      </main>
    </div>
  );
};

export default AppShell;
